import { ReactNode } from "react";
import { createPortal } from "react-dom";

type PortalProps = {
	children: ReactNode;
	containerId: string;
};

export function Portal({ children, containerId }: PortalProps) {
	const mount = document.getElementById(containerId);

	if (!mount) {
		return null;
	}

	return createPortal(children, mount);
}
